export enum StorageKeys {
  token = 'token',
  refreshToken = 'refreshToken',
  organizationId = 'organizationId',
  parentOrganizationId = 'parentOrganizationId',
  subOrganizationId = 'subOrganizationId',
  sidebarOpened = 'sidebarOpened'
}
